import { render, staticRenderFns } from "./ExternalLink.vue?vue&type=template&id=3b1ae312&scoped=true&"
import script from "./ExternalLink.vue?vue&type=script&lang=js&"
export * from "./ExternalLink.vue?vue&type=script&lang=js&"
import style0 from "./ExternalLink.vue?vue&type=style&index=0&id=3b1ae312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1ae312",
  null
  
)

export default component.exports